import React, { useState } from "react";
import Error from "./Preisrechner/Error";
import Privat from "./Preisrechner/Tabs/Privat";
import Gewerbe from "./Preisrechner/Tabs/Gewerbe";
import stylelist from "stylelist";

const Preisrechner = (props) => {

    const [tab,setTab] = useState(props.type);
    const [showError, setShowError] = useState(false);
    const [errorText, setErrorText] = useState('Für dieses PLZ-Gebiet können wir Ihnen leider kein Angebot erstellen.');

    return <div className="calculator uo-calculator-2024">
        {
            showError?<Error errorText={errorText} setShowError={setShowError} />:null
        }

        <ul id="tabs" className="nav nav-tabs" data-tabs="tabs">
            <li className={stylelist([tab==='Privat', "active"])}><a onClick={()=>setTab('Privat')}>Privat</a></li>
            <li className={stylelist([tab==='Gewerbe', "active"])}><a onClick={()=>setTab('Gewerbe')}>Gewerbe</a></li>
        </ul>
        <div className="calculator-content clearfix">

            <div className="tab-content">
                {tab === 'Privat'?<Privat setShowError={setShowError} setErrorText={setErrorText} energy={props.energy}/>:<Gewerbe setShowError={setShowError} setErrorText={setErrorText} energy={props.energy}/>}
            </div>
        </div>
    </div>;
}

export default Preisrechner;
